import { defineComponent as _defineComponent } from 'vue'
import { closeClientelServe, visible } from '@/compose/clientelServe'

export default /*#__PURE__*/_defineComponent({
  __name: 'ClienteleServicesDialog',
  setup(__props) {

const userId = localStorage.getItem('userId')
const userName = localStorage.getItem('name')
// const campId = localStorage.getItem('campId')
const campName = localStorage.getItem('campName')
const campNum = localStorage.getItem('networkNumNew')
const networkInfo = localStorage.getItem('networkInfo')
const networkInfoJson = JSON.parse(networkInfo || '{}')
const mainVersion = networkInfoJson.versionList?.find((item: { identify: any }) => item.identify === networkInfoJson.finalVersion)
const nickName = `${userName}（${campName}）(${mainVersion?.versionName})`
const phone = localStorage.getItem('phone')
let src = `https://a8-im.7x24cc.com/phone_webChat.html?accountId=N000000047650&chatId=17a983b8-f13d-4495-9828-f99870412ae9`
if (userId && campNum && nickName && phone) {
    src = `https://a8-im.7x24cc.com/phone_webChat.html?accountId=N000000047650&chatId=17a983b8-f13d-4495-9828-f99870412ae9&visitorId=${userId}_${campNum}&nickName=${nickName}&phone=${phone}`
}
// 这个数据不需要响应式
// const src= `https://a8-im.7x24cc.com/phone_webChat.html?accountId=N000000047650&chatId=17a983b8-f13d-4495-9828-f99870412ae9&visitorId=${userId}_${campNum}&nickName=${nickName}&phone=${phone}`

// defineProps<{
//     visible: boolean
// }>()

// const emits = defineEmits<{
//     (e: 'update:visible', visible: boolean): void
// }>()

function close() {
    closeClientelServe()
}


return { __sfc: true,userId, userName, campName, campNum, networkInfo, networkInfoJson, mainVersion, nickName, phone, src, close, visible }
}

})